import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getStaffs } from "actions/teamActions";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const SelectStaff = ({ getStaffs, onChange }) => {
    const { t } = useTranslation();
    const [staffs, setStaffs] = useState([]);
    const [staff, setStaff] = useState("");

    useEffect(() => {
        getStaffs({ sizeperpage: 100 }).then((data) => {
            setStaffs(data?.data?.map((staff) => ({ value: staff?.user?._id, label: staff.user.email + " - " + staff?.user?.name })) || []);
        });
    }, [getStaffs]);

    return (
        <Select
            isClearable
            name="filter_staff"
            options={staffs}
            value={staffs.filter(({ value }) => value === staff)}
            className="basic-multi-select al-custom-select-search-variants al-filter-table"
            classNamePrefix="select"
            onChange={(data) => {
                setStaff(data?.value || "");
                onChange?.(data?.value || "");
            }}
            placeholder={t(`Select a staff ... `)}
            styles={{
                menu: (provided) => ({
                    ...provided,
                    minWidth: "450px",
                    zIndex: "9999"
                }),
                menuList: (provided) => ({
                    ...provided,
                    paddingBottom: "0px"
                }),
            }}
        />
    );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = { getStaffs };

export default connect(mapStateToProps, mapDispatchToProps)(SelectStaff);
